import "../styles/partnerList.css";

const PartnerList = ({ partners, selected, onSelect, onEdit, onDelete, isDeletingPartner, isEditingPartner }) => {
  return (
    <div className="partner-list">
      {partners.map(p => (
        <div key={p.id} className="partner-item">
          <button
            className={selected?.id === p.id ? "active" : ""}
            onClick={() => onSelect(p)}
          >
            {p.name}
          </button>

          {/* ✅ Show actions only when selected */}
          {selected?.id === p.id && (
            <div className="actions">
              <span
  onClick={() =>
    !isEditingPartner && onEdit(p)
  }
>
  {isEditingPartner ? "⏳" : "✏️"}
</span>

<span
  onClick={() =>
    !isDeletingPartner && onDelete(p)
  }
>
  {isDeletingPartner ? "⏳" : "🗑️"}
</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PartnerList;